<template>
  <div name="hres4ax-detail" class="hres4ax-detail">
    <div class="btn-zoom">
      <!-- <button type="button" class="btn bg-dark-gray" @click="zoom('+')"><i class="fa fa-search-plus"></i></button> -->
      <!-- <button type="button" class="btn bg-dark-gray" @click="zoom('-')"><i class="fa fa-search-minus"></i></button> -->
      <div><i class="item fa fa-search-plus" @click="zoom('+')"></i></div>
      <div><i class="item fa fa-search-minus" @click="zoom('-')"></i></div>
      <div><i class="item fa fa-search" @click="scale = 100"></i></div>
      <div class="scale">{{scale + '%'}}</div>
    </div>
    <orgchart :data="detail"
              :labels="labels"
              :style="'zoom: ' + this.scale + '%;'"
              :receivedOrgBodyDetail="receivedOrgBodyDetail"  />

    <div class="box-footer">
      <button type="button" class="btn bg-dark-gray" @click="toggle('index')"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
    </div>
  </div>
</template>

<script>
// import orgchart from 'components/hres4ax/orgchart'
import orgchart from 'components/orgchart/component'

export default {
  name: 'hres4ax-detail',
  data () {
    return {
      scale: 100
    }
  },
  methods: {
    zoom (sign) {
      let diffScale = 10
      if (sign === '+') {
        this.scale = this.scale + diffScale
      } else {
        this.scale = this.scale - diffScale
        this.scale = this.scale < diffScale ? diffScale : this.scale
      }
    }
  },
  props: [ 'labelsButton', 'labels', 'detail', 'toggle', 'receivedOrgBodyDetail' ],
  components: {
    orgchart
  }
}
</script>

<style lang="scss">
  .hres4ax-detail {
    overflow-x: auto;

    >.box-footer {
      padding-top: 40px;
    }
    .btn-zoom {
      position: fixed;
      z-index: 100;
      cursor: pointer;
      font-size: 25px;
      color: #999;
      .item:hover {
        color: #333;
      }
      .scale {
        font-size: 12px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// detail.vue?0af824de